import styles from '../../styles/modules/contacts/ContactsOfficesItem.module.scss';

const ContactsRequesitesItem = ({ office }) => {
  return (
    <div className={styles.item}>
      <h5 className={[styles.title, 'clear'].join(' ')}>{office.area}</h5>
      <div className={styles.address}>{office.address}</div>
      {office.workingDays && !!office.workingDays.length && (
        <div className={styles.group}>
          <div className={styles.subtext}>Время работы</div>
          {office.workingDays.map((value, index) => (
            <div className={styles.text} key={index}>
              <div className={styles.date}>{value.text}</div>
              <div className={styles.time}>{value.time}</div>
            </div>
          ))}
        </div>
      )}
      {office.phone && (
        <div className={styles.group}>
          <div className={styles.subtext}>Телефон</div>
          <a className={styles.text} href={`tel:${office.phone}`} style={{ fontSize: '1.2rem' }}>
            {office.phone}
          </a>
        </div>
      )}
    </div>
  );
};

export default ContactsRequesitesItem;
